<template>
  <autocomplete
    @pick="pick"
    @input="onInput"
    @clear="options = []"
    :fill-on-pick="true"
    :options="options"
    v-slot="slotProps"
    class="users-autocomplete"
  >
    <div class="user-option">
      <div class="user-option-name">
        {{ slotProps.option.first_name }} {{ slotProps.option.last_name }}
      </div>
      <div class="user-option-username">
        {{ slotProps.option.username }}
      </div>
    </div>
  </autocomplete>
</template>

<script lang="ts">
import api from "@/api";
import { User } from "@/models";
import { Options, Vue } from "vue-class-component";
import Autocomplete from "./Autocomplete.vue";

@Options({
  components: {
    Autocomplete,
  },
  data() {
    return {
      options: [],
    };
  },
})
export default class UsersAutocomplete extends Vue {
  options!: User[];
  users!: User[];

  pick(user: User) {
    this.$emit("pick", user);
    this.options = [];
  }

  async loadOptions(value: string) {
    value = value.toLowerCase();
    this.options = await api.users.search(value);
  }

  onInput(value: string) {
    this.loadOptions(value);
  }
}
</script>

<style lang="scss">
.users-autocomplete {
  .autocomplete-options-item {
    height: 36px;
  }
}
.user-option {
  padding: 4px 12px;
}

.user-option-name {
  font-weight: bold;
  line-height: 1.2em;
}

.user-option-username {
  font-size: 0.8em;
}
</style>
